import React, { useState } from 'react';
import './RestGallery.css';
import { ArrowLeft, Play } from 'lucide-react';
import { createPortal } from 'react-dom';

const RestGallery = ({ isOpen, onClose, images, restaurantName, priceForTwo }) => {
    const [activeTab, setActiveTab] = useState('All');
    const [selectedImageIndex, setSelectedImageIndex] = useState(null);

    if (!isOpen) return null;

    const handleBack = () => {
        if (selectedImageIndex !== null) {
            setSelectedImageIndex(null);
        } else {
            onClose();
        }
    };

    const tabs = [
        { id: 'All', label: 'All' },
        { id: 'Food', label: 'Food' },
        { id: 'Ambience', label: 'Ambience' },
        { id: 'Other', label: 'Other' }
    ];


    const getFilteredImages = () => {
        if (activeTab === 'All') return images;
        return images.filter(img => img.type?.toLowerCase() === activeTab.toLowerCase());
    };

    const filteredImages = getFilteredImages();

    // Use Portal to render at document root to ensure it covers everything
    return createPortal(
        <div className="rest-gallery-overlay">
            <div className="gallery-header">
                <button className="gallery-back-btn" onClick={handleBack}>
                    <ArrowLeft size={24} />
                </button>
                <div className="gallery-title-container">
                    <h3 className="gallery-title">{restaurantName || "Restaurant Photos"}</h3>
                    <span className="gallery-subtitle">{priceForTwo || "₹3,000 for two"}</span>
                </div>
            </div>

            <div className="gallery-tabs">
                {tabs.map(tab => (
                    <button
                        key={tab.id}
                        className={`gallery-tab ${activeTab === tab.id ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab.id)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            <div className="gallery-content">
                {selectedImageIndex !== null ? (
                    <div className="single-image-view">
                        <div className="main-image-container">
                            <img
                                src={filteredImages[selectedImageIndex]?.imageURL}
                                alt="Selected"
                                className="main-image"
                            />
                        </div>

                        <div className="thumbnails-strip">
                            {filteredImages.map((img, idx) => (
                                <div
                                    key={idx}
                                    className={`thumbnail-item ${selectedImageIndex === idx ? 'active' : ''}`}
                                    onClick={() => setSelectedImageIndex(idx)}
                                >
                                    <img src={img.imageURL} alt={`Thumbnail ${idx}`} />
                                </div>
                            ))}
                        </div>
                    </div>
                ) : (
                    filteredImages.length > 0 ? (
                        <div className="gallery-grid">
                            {filteredImages.map((img, idx) => (
                                <div
                                    key={idx}
                                    className="gallery-item"
                                    onClick={() => setSelectedImageIndex(idx)}
                                >
                                    <img src={img.imageURL} alt={`Gallery item ${idx}`} loading="lazy" />
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="gallery-empty">
                            <p>No photos available in {activeTab}</p>
                        </div>
                    )
                )}
            </div>
        </div>,
        document.body
    );
};

export default RestGallery;
